import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSimplrAccountIdOfSelectedTicket } from '../../../../extractFromState';
import { getCustomerIdFromOrder, getShopNameOfSelectedOrder } from '../../../../selectors/tools';
import { getOrderingSystem } from '../../../../selectors/tools';
import {
  NotesSpinnerWrapper,
  NotesSubTitle,
  NotesText,
  NotesTitle,
  NotesWrapper,
} from './DTCustomerProfileNotesWidget.styles';
import { fetchCustomerInfo } from '../../../../api/decisionTree';
import SmallLoading from '../../../common/SmallLoading/SmallLoading';
import { handleError } from '../../../../services/ErrorService/ErrorService';

const DTCustomerProfileNotesWidget = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [notes, setNotes] = useState('');
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const shopName = useSelector(getShopNameOfSelectedOrder);
  const customerId = useSelector(getCustomerIdFromOrder);
  const orderingSystem = useSelector(getOrderingSystem);

  const fetchNotes = useCallback(async () => {
    try {
      setIsLoading(true);
      const result = await fetchCustomerInfo(customerId, simplrAccountId, shopName, orderingSystem);
      setNotes(result.customer?.note || 'No notes found.');
    } catch (error) {
      handleError({ error, customMessage: 'Error fetching customer notes', showPopup: true });
    } finally {
      setIsLoading(false);
    }
  }, [customerId, simplrAccountId, shopName, orderingSystem]);

  useEffect(() => {
    fetchNotes();
  }, [fetchNotes]);

  return (
    <NotesWrapper>
      <NotesTitle>Below are Shopify customer's profile notes</NotesTitle>
      <NotesSubTitle>This customer was flagged with the following notes in profile</NotesSubTitle>
      {isLoading ? (
        <NotesSpinnerWrapper data-testid="notes-spinner-wrapper">
          <SmallLoading />
        </NotesSpinnerWrapper>
      ) : (
        <NotesText>{notes}</NotesText>
      )}
    </NotesWrapper>
  );
};

export default DTCustomerProfileNotesWidget;
